export default "__VITE_ASSET__BHDe4zS6__"